/**
 * Clothing hanger placeholder (no upload icon inside)
 * Used in empty clothing panel state for "Upload Clothing"
 */
const OutfitPlaceholder = ({ size = 160, className = '' }) => {
  const rawScale = size / 200;
  const scale = 0.3 + rawScale * 0.7;
  const hangerW = Math.round(56 * scale);
  const hangerH = Math.round(40 * scale);

  return (
    <div
      className={`placeholder-drop-zone ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: Math.max(12, Math.round(20 * rawScale)),
        border: '2px dashed #3bbaa8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        cursor: 'pointer',
        transition: 'background 0.2s',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        WebkitTouchCallout: 'none'
      }}
    >
      {/* Hanger icon */}
      <svg width={hangerW} height={hangerH} viewBox="0 0 56 40">
        <circle cx="28" cy="4" r="3" fill="none" stroke="#3bbaa8" strokeWidth="2" />
        <path d="M28 7 L28 12" stroke="#3bbaa8" strokeWidth="2" strokeLinecap="round" />
        <path d="M28 12 L6 28 C3 30, 4 34, 8 34 L48 34 C52 34, 53 30, 50 28 Z" fill="none" stroke="#3bbaa8" strokeWidth="2" strokeLinejoin="round" />
      </svg>
    </div>
  );
};

export default OutfitPlaceholder;
